module.exports = "../dist/img/back1.35b2.png";